<div class="pb-3">
    <p-dialog
        [(visible)]="visible"
        [modal]="false"
        [header]="'service.settings.general.medicalProcedure.add' | translate"
        styleClass="p-dialog-width-50"
        [baseZIndex]="2000"
    >
        <app-search-medical-procedure
            [form]="form"
            [label]="'service.settings.general.medicalProcedure.fields.code' | translate"
        ></app-search-medical-procedure>

        <ng-template #footer>
            <app-action-buttons (primaryClickEvent)="createProcedure()"
                (secondaryClickEvent)="show(false)"></app-action-buttons>
        </ng-template>
    </p-dialog>

    <app-card-table
        #procedureGrid
        tableKey="serviceProcedures"
        [tableTitle]="'service.settings.general.medicalProcedure.labelMulti'"
        [columns]="columns"
        translatePrefix="service.settings.general.medicalProcedure."
        [hideCheckboxes]="true"
        [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [routeParams.serviceId()] }]]"
        [gridData]="$any(store.data.getServiceMedicalProcedures())"
        [refreshCallback]="store.api.getServiceMedicalProcedures"
        (detailCallback)="goToDetail($event)"
        (createCallback)="show(true)"
        (deleteCallbackWithEvent)="deleteProcedure($event)"
        [defaultSorters]="[{ column: 'codes', direction: 'ASC' }]"
    >
        <ng-template pTemplate="active" let-item="item">
            <app-green-or-red-dot [value]="item.active" (click)="setActive(item)"></app-green-or-red-dot>
        </ng-template>

        <ng-template pTemplate="rule" let-item="item">
            <div class="flex gap-small">
                @let rules = item.procedure.rule?.split(',') || [];
                @for (rule of rules; track rule) {
                    <app-tag [label]="rule.trim()" [rounded]="true"></app-tag>
                }
            </div>
        </ng-template>

        <ng-template pTemplate="name" let-item="item">
            @let data = (item | transformSingleServiceProcedure)[0];
            @if (data) {
                <div>{{ data.originalDescription || '' }}</div>
                @if (data.originalDescription != data.description) {
                    <div class="text-sm text-secondary mt-2">{{ data.description }}</div>
                }
            }
        </ng-template>
    </app-card-table>

</div>
